import { encryptValue } from "../../../utils/common";
import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "./apiService";


  const userLogin = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    let {email,password}=params
    let param = {email}
    config.headers["password"] = encryptValue(password)
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.auth.login}`,
      method: "POST",
      data: param,
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const logout = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.auth.logout}`,
      method: "POST",
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const resetPassword = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.auth.resetPassword}`,
      method: "PUT",
      data:params,
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  
  const forgotPassword = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.auth.forgotPassword}`,
      method: "PUT",
      data:params,
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const sendOtp = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.auth.sendOtp}`,
      method: "POST",
      data:params,
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const verifyOtp = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.auth.verifyOtp}`,
      method: "POST",
      data:params,
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  const forgotPasswordForAdmin = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.auth.forgotPasswordForAdmin}`,
      method: "PUT",
      data:params,
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

    const switchAccounts = (params) => {
    const { axiosInstance,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.auth.switchAccounts}`,
      method: "GET",
      params:params,
      headers: config.headers||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };
  export default {
    userLogin,
    logout,
    resetPassword,
    forgotPassword,
    verifyOtp,
    sendOtp,
    forgotPasswordForAdmin,
    switchAccounts
    
  }